/*eslint-disable */

import AUDIO from "./audios"
import { useEffect } from "react"

export default function useCustomAudio(volume: string, sound: boolean) {
  useEffect(() => {
    Object.keys(AUDIO).map((key: any) => {
      // @ts-ignore
      AUDIO[key].volume = volume
      // @ts-ignore
      AUDIO[key].muted = !sound
    })
  }, [sound, volume])

  return AUDIO
}
